module.exports = __webpack_public_path__ + "img/Head-bj.8ce2c486.png";